/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./types";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const processAccountSync = /* GraphQL */ `mutation ProcessAccountSync($tisAccountId: String!) {
  processAccountSync(tisAccountId: $tisAccountId) {
    data {
      tenantIDs
      assetsTypeInfo
      modelsInfo
      assetsInfo {
        newAssets
        updatedAssets
        __typename
      }
      locationInfo {
        newCountries
        newStates
        newCities
        newBuildings
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ProcessAccountSyncMutationVariables,
  APITypes.ProcessAccountSyncMutation
>;
export const syncTenantListTisData = /* GraphQL */ `mutation SyncTenantListTisData($tenantIDs: [String]!) {
  syncTenantListTisData(tenantIDs: $tenantIDs) {
    data {
      tenantIDs
      assetsTypeInfo
      modelsInfo
      assetsInfo {
        newAssets
        updatedAssets
        __typename
      }
      locationInfo {
        newCountries
        newStates
        newCities
        newBuildings
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SyncTenantListTisDataMutationVariables,
  APITypes.SyncTenantListTisDataMutation
>;
export const fetchCognitoUsers = /* GraphQL */ `mutation FetchCognitoUsers {
  fetchCognitoUsers {
    data
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FetchCognitoUsersMutationVariables,
  APITypes.FetchCognitoUsersMutation
>;
export const createAsset = /* GraphQL */ `mutation CreateAsset($data: AssetInput!) {
  createAsset(data: $data) {
    data {
      id
      number
      displayNumber
      userId
      assetTag
      description
      makeId
      modelId
      state
      usefulLife
      acquisitionCostValue
      lastMaintenanceDate
      nextScheduledMaintenanceDate
      assignedToId
      assetTypeId
      condition
      maintenanceCostValue
      currentBookValue
      installDate
      decommissionDate
      locationId
      image
      purchaseOrderId
      utilizationData
      reasonForDecommission
      serialNumber
      thirdPartyId
      source
      totalCostOfOwnershipValue
      repairCostValue
      warrantyExpiration
      downTime
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      woCount
      findingsCount
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetRisk
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      isParent
      thirdPartyParentId
      thirdPartyHierarchyPath
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssetMutationVariables,
  APITypes.CreateAssetMutation
>;
export const updateAsset = /* GraphQL */ `mutation UpdateAsset($id: String!, $data: AssetInput!) {
  updateAsset(id: $id, data: $data) {
    data {
      id
      number
      displayNumber
      userId
      assetTag
      description
      makeId
      modelId
      state
      usefulLife
      acquisitionCostValue
      lastMaintenanceDate
      nextScheduledMaintenanceDate
      assignedToId
      assetTypeId
      condition
      maintenanceCostValue
      currentBookValue
      installDate
      decommissionDate
      locationId
      image
      purchaseOrderId
      utilizationData
      reasonForDecommission
      serialNumber
      thirdPartyId
      source
      totalCostOfOwnershipValue
      repairCostValue
      warrantyExpiration
      downTime
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      woCount
      findingsCount
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetRisk
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      isParent
      thirdPartyParentId
      thirdPartyHierarchyPath
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssetMutationVariables,
  APITypes.UpdateAssetMutation
>;
export const deleteAsset = /* GraphQL */ `mutation DeleteAsset($id: String!) {
  deleteAsset(id: $id) {
    data {
      id
      number
      displayNumber
      userId
      assetTag
      description
      makeId
      modelId
      state
      usefulLife
      acquisitionCostValue
      lastMaintenanceDate
      nextScheduledMaintenanceDate
      assignedToId
      assetTypeId
      condition
      maintenanceCostValue
      currentBookValue
      installDate
      decommissionDate
      locationId
      image
      purchaseOrderId
      utilizationData
      reasonForDecommission
      serialNumber
      thirdPartyId
      source
      totalCostOfOwnershipValue
      repairCostValue
      warrantyExpiration
      downTime
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      woCount
      findingsCount
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      assetRisk
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      isParent
      thirdPartyParentId
      thirdPartyHierarchyPath
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssetMutationVariables,
  APITypes.DeleteAssetMutation
>;
export const seeWorkOrderAsUser = /* GraphQL */ `mutation SeeWorkOrderAsUser($workOrderId: String!) {
  seeWorkOrderAsUser(workOrderId: $workOrderId) {
    data
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SeeWorkOrderAsUserMutationVariables,
  APITypes.SeeWorkOrderAsUserMutation
>;
export const createWorkOrder = /* GraphQL */ `mutation CreateWorkOrder($data: WorkOrderInput!) {
  createWorkOrder(data: $data) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      userId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      locationId
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      assetLocation {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      thirdPartyNumber
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkOrderMutationVariables,
  APITypes.CreateWorkOrderMutation
>;
export const updateWorkOrder = /* GraphQL */ `mutation UpdateWorkOrder($id: String!, $data: WorkOrderInput!) {
  updateWorkOrder(id: $id, data: $data) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      userId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      locationId
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      assetLocation {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      thirdPartyNumber
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkOrderMutationVariables,
  APITypes.UpdateWorkOrderMutation
>;
export const deleteWorkOrder = /* GraphQL */ `mutation DeleteWorkOrder($id: String!) {
  deleteWorkOrder(id: $id) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      userId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      locationId
      location {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      assetLocation {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      thirdPartyNumber
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkOrderMutationVariables,
  APITypes.DeleteWorkOrderMutation
>;
export const bulkUpdateWorkOrder = /* GraphQL */ `mutation BulkUpdateWorkOrder($data: BulkUpdateData) {
  bulkUpdateWorkOrder(data: $data) {
    updatedCount
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BulkUpdateWorkOrderMutationVariables,
  APITypes.BulkUpdateWorkOrderMutation
>;
export const createWorkOrdersByTemplateList = /* GraphQL */ `mutation CreateWorkOrdersByTemplateList(
  $assetIdList: [String]!
  $templateIdList: [String]!
) {
  createWorkOrdersByTemplateList(
    assetIdList: $assetIdList
    templateIdList: $templateIdList
  ) {
    data {
      id
      displayNumber
      tenantId
      tenant {
        id
        name
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      userId
      locationId
      location {
        id
        name
        __typename
      }
      assetLocation {
        id
        name
        __typename
      }
      dueDate
      startDate
      endDate
      duration
      plannedStartDate
      plannedEndDate
      assetId
      asset {
        id
        assetTag
        serialNumber
        description
        makeId
        modelId
        tenantId
        state
        assetTypeId
        __typename
      }
      assignmentGroupId
      assignedToId
      assignedTo {
        id
        name
        __typename
      }
      businessDownTime
      downTimeStart
      downTimeEnd
      category
      checklist
      closedNotes
      closedAt
      closedById
      closedBy {
        id
        name
        __typename
      }
      notes
      title
      description
      estimatedCostValue
      actualCostValue
      estimatedEffort
      actualEffort
      expectedOperationalDate
      impact
      priority
      dependsOnWorkOrderId
      state
      type
      templateId
      isArchived
      findingId
      seenByAssignee
      assignmentDateTime
      seenDateTime
      startOfWorkDateTime
      endOfWorkDateTime
      assetModel {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      thirdPartyNumber
      isParent
      parentId
      lineItemsCount
      parent {
        id
        displayNumber
        tenantId
        tenant {
          id
          name
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        userId
        locationId
        location {
          id
          name
          __typename
        }
        assetLocation {
          id
          name
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          assetTag
          serialNumber
          description
          makeId
          modelId
          tenantId
          state
          assetTypeId
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          name
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          name
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        isParent
        parentId
        lineItemsCount
        parent {
          id
          displayNumber
          tenantId
          tenant {
            id
            name
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          number
          userId
          locationId
          location {
            id
            name
            __typename
          }
          assetLocation {
            id
            name
            __typename
          }
          dueDate
          startDate
          endDate
          duration
          plannedStartDate
          plannedEndDate
          assetId
          asset {
            id
            assetTag
            serialNumber
            description
            makeId
            modelId
            tenantId
            state
            assetTypeId
            __typename
          }
          assignmentGroupId
          assignedToId
          assignedTo {
            id
            name
            __typename
          }
          businessDownTime
          downTimeStart
          downTimeEnd
          category
          checklist
          closedNotes
          closedAt
          closedById
          closedBy {
            id
            name
            __typename
          }
          notes
          title
          description
          estimatedCostValue
          actualCostValue
          estimatedEffort
          actualEffort
          expectedOperationalDate
          impact
          priority
          dependsOnWorkOrderId
          state
          type
          templateId
          isArchived
          findingId
          seenByAssignee
          assignmentDateTime
          seenDateTime
          startOfWorkDateTime
          endOfWorkDateTime
          assetModel {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          thirdPartyId
          thirdPartySource
          thirdPartyNumber
          isParent
          parentId
          lineItemsCount
          parent {
            id
            displayNumber
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            number
            userId
            locationId
            dueDate
            startDate
            endDate
            duration
            plannedStartDate
            plannedEndDate
            assetId
            assignmentGroupId
            assignedToId
            businessDownTime
            downTimeStart
            downTimeEnd
            category
            checklist
            closedNotes
            closedAt
            closedById
            notes
            title
            description
            estimatedCostValue
            actualCostValue
            estimatedEffort
            actualEffort
            expectedOperationalDate
            impact
            priority
            dependsOnWorkOrderId
            state
            type
            templateId
            isArchived
            findingId
            seenByAssignee
            assignmentDateTime
            seenDateTime
            startOfWorkDateTime
            endOfWorkDateTime
            thirdPartyId
            thirdPartySource
            thirdPartyNumber
            isParent
            parentId
            lineItemsCount
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    totalCount
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkOrdersByTemplateListMutationVariables,
  APITypes.CreateWorkOrdersByTemplateListMutation
>;
export const createWorkOrderTemplate = /* GraphQL */ `mutation CreateWorkOrderTemplate($data: WorkOrderTemplateInput!) {
  createWorkOrderTemplate(data: $data) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      title
      type
      category
      description
      userId
      locationId
      assignmentGroupId
      notes
      estimatedCostValue
      estimatedEffort
      impact
      priority
      executionInterval
      assetManufacturerId
      assetModelId
      assetTypeId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkOrderTemplateMutationVariables,
  APITypes.CreateWorkOrderTemplateMutation
>;
export const updateWorkOrderTemplate = /* GraphQL */ `mutation UpdateWorkOrderTemplate($id: String!, $data: WorkOrderTemplateInput!) {
  updateWorkOrderTemplate(id: $id, data: $data) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      title
      type
      category
      description
      userId
      locationId
      assignmentGroupId
      notes
      estimatedCostValue
      estimatedEffort
      impact
      priority
      executionInterval
      assetManufacturerId
      assetModelId
      assetTypeId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkOrderTemplateMutationVariables,
  APITypes.UpdateWorkOrderTemplateMutation
>;
export const deleteWorkOrderTemplate = /* GraphQL */ `mutation DeleteWorkOrderTemplate($id: String!) {
  deleteWorkOrderTemplate(id: $id) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      number
      title
      type
      category
      description
      userId
      locationId
      assignmentGroupId
      notes
      estimatedCostValue
      estimatedEffort
      impact
      priority
      executionInterval
      assetManufacturerId
      assetModelId
      assetTypeId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkOrderTemplateMutationVariables,
  APITypes.DeleteWorkOrderTemplateMutation
>;
export const createModel = /* GraphQL */ `mutation CreateModel($data: CreateModelInput!) {
  createModel(data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      oemPartNumber
      name
      manufacturerId
      assetTypeId
      probability
      severity
      riskScore
      picture
      specification
      usefulLife
      inUseStatus
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateModelMutationVariables,
  APITypes.CreateModelMutation
>;
export const updateModel = /* GraphQL */ `mutation UpdateModel($id: String!, $data: UpdateModelInput!) {
  updateModel(id: $id, data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      oemPartNumber
      name
      manufacturerId
      assetTypeId
      probability
      severity
      riskScore
      picture
      specification
      usefulLife
      inUseStatus
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateModelMutationVariables,
  APITypes.UpdateModelMutation
>;
export const deleteModel = /* GraphQL */ `mutation DeleteModel($id: String!) {
  deleteModel(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      oemPartNumber
      name
      manufacturerId
      assetTypeId
      probability
      severity
      riskScore
      picture
      specification
      usefulLife
      inUseStatus
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      manufacturer {
        id
        name
        description
        countryId
        website
        contactPerson
        contactEmail
        contactPhone
        address
        warrantyPolicies
        slaDetails
        vendorPortalLink
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        inUseStatus
        __typename
      }
      assetType {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        name
        description
        category
        criticalityLevel
        expectedUsefulLife
        defaultWarrantyPeriod
        defaultRiskScore
        manufacturerRecommendations
        image
        thirdPartyId
        thirdPartySource
        inUseStatus
        __typename
      }
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteModelMutationVariables,
  APITypes.DeleteModelMutation
>;
export const createManufacturer = /* GraphQL */ `mutation CreateManufacturer($data: ManufacturerInput!) {
  createManufacturer(data: $data) {
    data {
      id
      name
      description
      countryId
      website
      contactPerson
      contactEmail
      contactPhone
      address
      warrantyPolicies
      slaDetails
      vendorPortalLink
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateManufacturerMutationVariables,
  APITypes.CreateManufacturerMutation
>;
export const updateManufacturer = /* GraphQL */ `mutation UpdateManufacturer($id: String!, $data: ManufacturerInput!) {
  updateManufacturer(id: $id, data: $data) {
    data {
      id
      name
      description
      countryId
      website
      contactPerson
      contactEmail
      contactPhone
      address
      warrantyPolicies
      slaDetails
      vendorPortalLink
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateManufacturerMutationVariables,
  APITypes.UpdateManufacturerMutation
>;
export const deleteManufacturer = /* GraphQL */ `mutation DeleteManufacturer($id: String!) {
  deleteManufacturer(id: $id) {
    data {
      id
      name
      description
      countryId
      website
      contactPerson
      contactEmail
      contactPhone
      address
      warrantyPolicies
      slaDetails
      vendorPortalLink
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      thirdPartyId
      thirdPartySource
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteManufacturerMutationVariables,
  APITypes.DeleteManufacturerMutation
>;
export const createFinding = /* GraphQL */ `mutation CreateFinding($data: FindingInput!) {
  createFinding(data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      displayNumber
      shortDescription
      priority
      estimatedRepairCost
      plannedRepairDate
      description
      cause
      symptom
      picture
      reportedOn
      workOrderId
      type
      reportedById
      status
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      locationId
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      isArchived
      thirdPartyId
      thirdPartySource
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFindingMutationVariables,
  APITypes.CreateFindingMutation
>;
export const updateFinding = /* GraphQL */ `mutation UpdateFinding($id: String!, $data: UpdateFindingInput!) {
  updateFinding(id: $id, data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      displayNumber
      shortDescription
      priority
      estimatedRepairCost
      plannedRepairDate
      description
      cause
      symptom
      picture
      reportedOn
      workOrderId
      type
      reportedById
      status
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      locationId
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      isArchived
      thirdPartyId
      thirdPartySource
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFindingMutationVariables,
  APITypes.UpdateFindingMutation
>;
export const deleteFinding = /* GraphQL */ `mutation DeleteFinding($id: String!) {
  deleteFinding(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      number
      displayNumber
      shortDescription
      priority
      estimatedRepairCost
      plannedRepairDate
      description
      cause
      symptom
      picture
      reportedOn
      workOrderId
      type
      reportedById
      status
      assetId
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      locationId
      model {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        oemPartNumber
        name
        manufacturerId
        assetTypeId
        probability
        severity
        riskScore
        picture
        specification
        usefulLife
        inUseStatus
        thirdPartyId
        thirdPartySource
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      isArchived
      thirdPartyId
      thirdPartySource
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFindingMutationVariables,
  APITypes.DeleteFindingMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($data: UserInput!) {
  createUser(data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      groups
      email
      name
      phone
      role
      address
      location
      tenants
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser($id: String!, $data: UserInput!) {
  updateUser(id: $id, data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      groups
      email
      name
      phone
      role
      address
      location
      tenants
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser($id: String!) {
  deleteUser(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      groups
      email
      name
      phone
      role
      address
      location
      tenants
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createTenant = /* GraphQL */ `mutation CreateTenant($data: TenantInput!) {
  createTenant(data: $data) {
    data {
      id
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      address
      contacts
      isActive
      cognitoGroupName
      tisId
      plan
      tisSyncedAt
      dataSource
      dataSourceId
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const updateTenant = /* GraphQL */ `mutation UpdateTenant($id: String!, $data: TenantInput!) {
  updateTenant(id: $id, data: $data) {
    data {
      id
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      address
      contacts
      isActive
      cognitoGroupName
      tisId
      plan
      tisSyncedAt
      dataSource
      dataSourceId
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantMutationVariables,
  APITypes.UpdateTenantMutation
>;
export const deleteTenant = /* GraphQL */ `mutation DeleteTenant($id: String!) {
  deleteTenant(id: $id) {
    data {
      id
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      address
      contacts
      isActive
      cognitoGroupName
      tisId
      plan
      tisSyncedAt
      dataSource
      dataSourceId
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantMutationVariables,
  APITypes.DeleteTenantMutation
>;
export const createLocation = /* GraphQL */ `mutation CreateLocation($data: LocationInput!) {
  createLocation(data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation($id: String!, $data: LocationInput!) {
  updateLocation(id: $id, data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation($id: String!) {
  deleteLocation(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      name
      notes
      lat
      lng
      level
      parentId
      rootId
      thirdPartyId
      source
      inUseStatus
      address
      buildingAddress
      parent {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        notes
        lat
        lng
        level
        parentId
        rootId
        thirdPartyId
        source
        inUseStatus
        address
        buildingAddress
        parent {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        tisSyncedAt
        __typename
      }
      tisSyncedAt
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLocationMutationVariables,
  APITypes.DeleteLocationMutation
>;
export const createExpense = /* GraphQL */ `mutation CreateExpense($data: ExpenseInput!) {
  createExpense(data: $data) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      title
      description
      type
      status
      number
      amount
      purchaseOrderId
      workOrderId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExpenseMutationVariables,
  APITypes.CreateExpenseMutation
>;
export const updateExpense = /* GraphQL */ `mutation UpdateExpense($id: String!, $data: ExpenseInput!) {
  updateExpense(id: $id, data: $data) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      title
      description
      type
      status
      number
      amount
      purchaseOrderId
      workOrderId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExpenseMutationVariables,
  APITypes.UpdateExpenseMutation
>;
export const deleteExpense = /* GraphQL */ `mutation DeleteExpense($id: String!) {
  deleteExpense(id: $id) {
    data {
      id
      displayNumber
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      title
      description
      type
      status
      number
      amount
      purchaseOrderId
      workOrderId
      user {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExpenseMutationVariables,
  APITypes.DeleteExpenseMutation
>;
export const createAssetType = /* GraphQL */ `mutation CreateAssetType($data: AssetTypeInput!) {
  createAssetType(data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      name
      description
      category
      criticalityLevel
      expectedUsefulLife
      defaultWarrantyPeriod
      defaultRiskScore
      manufacturerRecommendations
      image
      thirdPartyId
      thirdPartySource
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssetTypeMutationVariables,
  APITypes.CreateAssetTypeMutation
>;
export const updateAssetType = /* GraphQL */ `mutation UpdateAssetType($id: String!, $data: AssetTypeInput!) {
  updateAssetType(id: $id, data: $data) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      name
      description
      category
      criticalityLevel
      expectedUsefulLife
      defaultWarrantyPeriod
      defaultRiskScore
      manufacturerRecommendations
      image
      thirdPartyId
      thirdPartySource
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssetTypeMutationVariables,
  APITypes.UpdateAssetTypeMutation
>;
export const deleteAssetType = /* GraphQL */ `mutation DeleteAssetType($id: String!) {
  deleteAssetType(id: $id) {
    data {
      id
      tenantId
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      createdAt
      createdBy
      createdByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      updatedAt
      updatedBy
      updatedByUser {
        id
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        groups
        email
        name
        phone
        role
        address
        location
        tenants
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        __typename
      }
      name
      description
      category
      criticalityLevel
      expectedUsefulLife
      defaultWarrantyPeriod
      defaultRiskScore
      manufacturerRecommendations
      image
      thirdPartyId
      thirdPartySource
      inUseStatus
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssetTypeMutationVariables,
  APITypes.DeleteAssetTypeMutation
>;
export const createAttachment = /* GraphQL */ `mutation CreateAttachment($data: AttachmentInput!) {
  createAttachment(data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachmentMutationVariables,
  APITypes.CreateAttachmentMutation
>;
export const updateAttachment = /* GraphQL */ `mutation UpdateAttachment($id: String!, $data: AttachmentInput!) {
  updateAttachment(id: $id, data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttachmentMutationVariables,
  APITypes.UpdateAttachmentMutation
>;
export const deleteAttachment = /* GraphQL */ `mutation DeleteAttachment($id: String!) {
  deleteAttachment(id: $id) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachmentMutationVariables,
  APITypes.DeleteAttachmentMutation
>;
export const deleteAttachmentAndCleanRefs = /* GraphQL */ `mutation DeleteAttachmentAndCleanRefs(
  $id: String!
  $data: DeleteAttachmentCleanInput
) {
  deleteAttachmentAndCleanRefs(id: $id, data: $data) {
    data {
      id
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      fileName
      originalFileName
      path
      downloadUrl
      mimeType
      size
      description
      relatedTable
      relatedItem
      type
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachmentAndCleanRefsMutationVariables,
  APITypes.DeleteAttachmentAndCleanRefsMutation
>;
export const getAttachmentUploadUrls = /* GraphQL */ `mutation GetAttachmentUploadUrls(
  $files: [AttachmentUploadBaseData]
  $tenantId: ID
) {
  getAttachmentUploadUrls(files: $files, tenantId: $tenantId) {
    data {
      uploadUrl
      uploadName
      originalFileName
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetAttachmentUploadUrlsMutationVariables,
  APITypes.GetAttachmentUploadUrlsMutation
>;
export const updateAlert = /* GraphQL */ `mutation UpdateAlert($id: String!, $data: AlertInput!) {
  updateAlert(id: $id, data: $data) {
    data {
      id
      number
      displayNumber
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assetId
      daysFailed
      tisStatus
      state
      firstException
      worstException
      lastException
      impactComfort
      impactEnergy
      impactReliability
      testValue
      exceptionName
      suggestionDescription
      suggestionCauses
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      workOrderId
      finding {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        displayNumber
        shortDescription
        priority
        estimatedRepairCost
        plannedRepairDate
        description
        cause
        symptom
        picture
        reportedOn
        workOrderId
        type
        reportedById
        status
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        locationId
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        isArchived
        thirdPartyId
        thirdPartySource
        __typename
      }
      findingId
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlertMutationVariables,
  APITypes.UpdateAlertMutation
>;
export const createAlert = /* GraphQL */ `mutation CreateAlert($id: String!, $data: AlertInput!) {
  createAlert(id: $id, data: $data) {
    data {
      id
      number
      displayNumber
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assetId
      daysFailed
      tisStatus
      state
      firstException
      worstException
      lastException
      impactComfort
      impactEnergy
      impactReliability
      testValue
      exceptionName
      suggestionDescription
      suggestionCauses
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      workOrderId
      finding {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        displayNumber
        shortDescription
        priority
        estimatedRepairCost
        plannedRepairDate
        description
        cause
        symptom
        picture
        reportedOn
        workOrderId
        type
        reportedById
        status
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        locationId
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        isArchived
        thirdPartyId
        thirdPartySource
        __typename
      }
      findingId
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlertMutationVariables,
  APITypes.CreateAlertMutation
>;
export const deleteAlert = /* GraphQL */ `mutation DeleteAlert($id: String!, $data: AlertInput!) {
  deleteAlert(id: $id, data: $data) {
    data {
      id
      number
      displayNumber
      asset {
        id
        number
        displayNumber
        userId
        assetTag
        description
        makeId
        modelId
        state
        usefulLife
        acquisitionCostValue
        lastMaintenanceDate
        nextScheduledMaintenanceDate
        assignedToId
        assetTypeId
        condition
        maintenanceCostValue
        currentBookValue
        installDate
        decommissionDate
        locationId
        image
        purchaseOrderId
        utilizationData
        reasonForDecommission
        serialNumber
        thirdPartyId
        source
        totalCostOfOwnershipValue
        repairCostValue
        warrantyExpiration
        downTime
        tenantId
        createdAt
        createdBy
        updatedAt
        updatedBy
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetType {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          name
          description
          category
          criticalityLevel
          expectedUsefulLife
          defaultWarrantyPeriod
          defaultRiskScore
          manufacturerRecommendations
          image
          thirdPartyId
          thirdPartySource
          inUseStatus
          __typename
        }
        manufacturer {
          id
          name
          description
          countryId
          website
          contactPerson
          contactEmail
          contactPhone
          address
          warrantyPolicies
          slaDetails
          vendorPortalLink
          createdAt
          createdBy
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedAt
          updatedBy
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          thirdPartyId
          thirdPartySource
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          inUseStatus
          __typename
        }
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        woCount
        findingsCount
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        assetRisk
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        isParent
        thirdPartyParentId
        thirdPartyHierarchyPath
        __typename
      }
      assetId
      daysFailed
      tisStatus
      state
      firstException
      worstException
      lastException
      impactComfort
      impactEnergy
      impactReliability
      testValue
      exceptionName
      suggestionDescription
      suggestionCauses
      workOrder {
        id
        displayNumber
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        createdByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        updatedAt
        updatedBy
        updatedByUser {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        number
        userId
        user {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        locationId
        location {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        assetLocation {
          id
          tenantId
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          notes
          lat
          lng
          level
          parentId
          rootId
          thirdPartyId
          source
          inUseStatus
          address
          buildingAddress
          parent {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          tisSyncedAt
          __typename
        }
        dueDate
        startDate
        endDate
        duration
        plannedStartDate
        plannedEndDate
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        assignmentGroupId
        assignedToId
        assignedTo {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        businessDownTime
        downTimeStart
        downTimeEnd
        category
        checklist
        closedNotes
        closedAt
        closedById
        closedBy {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          groups
          email
          name
          phone
          role
          address
          location
          tenants
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        notes
        title
        description
        estimatedCostValue
        actualCostValue
        estimatedEffort
        actualEffort
        expectedOperationalDate
        impact
        priority
        dependsOnWorkOrderId
        state
        type
        templateId
        isArchived
        findingId
        seenByAssignee
        assignmentDateTime
        seenDateTime
        startOfWorkDateTime
        endOfWorkDateTime
        assetModel {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        thirdPartyId
        thirdPartySource
        thirdPartyNumber
        __typename
      }
      workOrderId
      finding {
        id
        tenantId
        tenant {
          id
          createdAt
          createdBy
          updatedAt
          updatedBy
          name
          address
          contacts
          isActive
          cognitoGroupName
          tisId
          plan
          tisSyncedAt
          dataSource
          dataSourceId
          __typename
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        number
        displayNumber
        shortDescription
        priority
        estimatedRepairCost
        plannedRepairDate
        description
        cause
        symptom
        picture
        reportedOn
        workOrderId
        type
        reportedById
        status
        assetId
        asset {
          id
          number
          displayNumber
          userId
          assetTag
          description
          makeId
          modelId
          state
          usefulLife
          acquisitionCostValue
          lastMaintenanceDate
          nextScheduledMaintenanceDate
          assignedToId
          assetTypeId
          condition
          maintenanceCostValue
          currentBookValue
          installDate
          decommissionDate
          locationId
          image
          purchaseOrderId
          utilizationData
          reasonForDecommission
          serialNumber
          thirdPartyId
          source
          totalCostOfOwnershipValue
          repairCostValue
          warrantyExpiration
          downTime
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          model {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            oemPartNumber
            name
            manufacturerId
            assetTypeId
            probability
            severity
            riskScore
            picture
            specification
            usefulLife
            inUseStatus
            thirdPartyId
            thirdPartySource
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          woCount
          findingsCount
          user {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          assetRisk
          location {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            notes
            lat
            lng
            level
            parentId
            rootId
            thirdPartyId
            source
            inUseStatus
            address
            buildingAddress
            tisSyncedAt
            __typename
          }
          isParent
          thirdPartyParentId
          thirdPartyHierarchyPath
          __typename
        }
        locationId
        model {
          id
          tenantId
          createdAt
          createdBy
          updatedAt
          updatedBy
          oemPartNumber
          name
          manufacturerId
          assetTypeId
          probability
          severity
          riskScore
          picture
          specification
          usefulLife
          inUseStatus
          thirdPartyId
          thirdPartySource
          tenant {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            address
            contacts
            isActive
            cognitoGroupName
            tisId
            plan
            tisSyncedAt
            dataSource
            dataSourceId
            __typename
          }
          manufacturer {
            id
            name
            description
            countryId
            website
            contactPerson
            contactEmail
            contactPhone
            address
            warrantyPolicies
            slaDetails
            vendorPortalLink
            createdAt
            createdBy
            updatedAt
            updatedBy
            thirdPartyId
            thirdPartySource
            tenantId
            inUseStatus
            __typename
          }
          assetType {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            name
            description
            category
            criticalityLevel
            expectedUsefulLife
            defaultWarrantyPeriod
            defaultRiskScore
            manufacturerRecommendations
            image
            thirdPartyId
            thirdPartySource
            inUseStatus
            __typename
          }
          createdByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          updatedByUser {
            id
            tenantId
            createdAt
            createdBy
            updatedAt
            updatedBy
            groups
            email
            name
            phone
            role
            address
            location
            tenants
            __typename
          }
          __typename
        }
        isArchived
        thirdPartyId
        thirdPartySource
        __typename
      }
      findingId
      thirdPartyId
      thirdPartySource
      tenant {
        id
        createdAt
        createdBy
        updatedAt
        updatedBy
        name
        address
        contacts
        isActive
        cognitoGroupName
        tisId
        plan
        tisSyncedAt
        dataSource
        dataSourceId
        __typename
      }
      tenantId
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlertMutationVariables,
  APITypes.DeleteAlertMutation
>;
export const bulkUpdateAlert = /* GraphQL */ `mutation BulkUpdateAlert($data: BulkUpdateData) {
  bulkUpdateAlert(data: $data) {
    updatedCount
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BulkUpdateAlertMutationVariables,
  APITypes.BulkUpdateAlertMutation
>;
export const importAssetFile = /* GraphQL */ `mutation ImportAssetFile($data: ImportFileInput!) {
  importAssetFile(data: $data) {
    data {
      totalRows
      successfulImports
      errors
      duplicates
      errorFileId
      __typename
    }
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ImportAssetFileMutationVariables,
  APITypes.ImportAssetFileMutation
>;
